import type { Monster } from "./types";

/**
 * Five stages with a GROWING inventory and a fresh loot pile each time.
 * The grid is wiped between stages. By design every stage's loot needs more
 * cells than the grid holds, so there is never room for everything — the
 * player must always choose what to leave behind.
 *
 *   stage          grid   cells   loot cells   surplus
 *   Goblin Scout   3×3      9        13           4
 *   Orc Brute      4×3     12        18           6
 *   Skeleton King  4×4     16        21           5
 *   Cave Troll     5×4     20        27           7
 *   Ancient Dragon 5×5     25        36          11
 */
export const MONSTERS: Monster[] = [
  {
    name: "Goblin Scout", icon: "👺", hp: 100, flavor: "A twitchy little thief with full pockets.",
    grid: { cols: 3, rows: 3 },
    loot: ["coin", "coin", "potion", "scroll", "bone", "skull"],
  },
  {
    name: "Orc Brute", icon: "👹", hp: 130, flavor: "It hoards what it cannot use.",
    grid: { cols: 4, rows: 3 },
    loot: ["gem", "axe", "shield", "key", "bone", "chalice", "dagger"],
  },
  {
    name: "Skeleton King", icon: "💀", hp: 145, flavor: "Crowned in the dark, still clutching its blade.",
    grid: { cols: 4, rows: 4 },
    loot: ["amulet", "sword", "crown", "potion", "urn", "coin", "ring", "skull"],
  },
  {
    name: "Cave Troll", icon: "🧌", hp: 175, flavor: "Its lair glitters beneath the grime.",
    grid: { cols: 5, rows: 4 },
    loot: ["ring", "bow", "shield", "gem", "skull", "bag", "sword", "chalice", "dagger", "coin"],
  },
  {
    name: "Ancient Dragon", icon: "🐉", hp: 235, flavor: "A lifetime of plunder, and you can take only a sliver.",
    grid: { cols: 5, rows: 5 },
    loot: ["crown", "trident", "ring", "gem", "amulet", "sword", "chalice", "urn", "coin", "coin", "shield", "bow", "skull"],
  },
];
